
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/membership/create",
      function () {
        return require("private-next-pages/membership/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/membership/create"])
      });
    }
  